import { useFormContext } from 'react-hook-form';
import { Checkbox } from '~/components/ui/forms/Checkbox';
import { TextInput } from '~/components/ui/forms/text-input';
import { TinyMceInput } from '~/components/ui/forms/tinymce-input';
import type { PageFormValues } from '~/utils/modules/page';

export function PageFormFields() {
  const { register } = useFormContext<PageFormValues>();

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-3 gap-6">
        <div className="col-span-2">
          <TextInput {...register('title')} label="Title" required />
        </div>
        <div>
          <TextInput
            {...register('pageName')}
            label="Internal page name"
            required
          />
        </div>
      </div>

      <TinyMceInput
        name="content"
        label="Content"
        config={{ height: 300 }}
        required
      />

      <Checkbox {...register('secured')} label="Secured" />
    </div>
  );
}
